import {
  createResource,
  postResource,
} from '@resource/resource'

import { prefixAPI } from '@resource/api'

const PASSWORD_GENERATOR = prefixAPI('gen-code/')

export const generatorResource = createResource(
  PASSWORD_GENERATOR, postResource
)



// WEBPACK FOOTER //
// ./src/js/services/password-generator.js